// src/components/common/ConfirmModal.jsx
// Modal de confirmación reutilizable — reemplaza window.confirm() en toda la
// app (política del proyecto: ver DESIGN.md "Do's and Don'ts"). Sigue el
// mismo lenguaje visual que el modal de eliminación original de
// ClaimsList.jsx (tarjeta glass, header/footer sticky, botón danger opcional).
import React, { useRef } from 'react';
import useDialogFocus from './useDialogFocus';
import './ConfirmModal.css';

// Semántica de diálogo (alertdialog con nombre y descripción), foco contenido y
// devuelto al disparador, y Escape = cancelar. El foco inicial cae en Cancelar.
const ConfirmDialog = ({
  icon = 'fa-circle-question',
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  closeLabel = 'Close',
  danger = false,
  loading = false,
  onConfirm,
  onCancel
}) => {
  const ref = useRef(null);
  const titleId = useRef(`cm-title-${Math.random().toString(36).slice(2, 9)}`).current;
  const onKeyDown = useDialogFocus(ref, { onEscape: () => { if (!loading) onCancel(); } });

  return (
    <div className="cm-overlay" onClick={onCancel}>
      <div className="cm-modal" ref={ref} role="alertdialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={`${titleId}-msg`} tabIndex={-1} onClick={(e) => e.stopPropagation()} onKeyDown={onKeyDown}>
        <div className="cm-header">
          <h3 id={titleId}><i className={`fa-solid ${icon}`} aria-hidden="true"></i>{title}</h3>
          <button type="button" className="cm-close" onClick={onCancel} aria-label={closeLabel}>
            <i className="fa-solid fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div className="cm-body">
          <p id={`${titleId}-msg`}>{message}</p>
        </div>
        <div className="cm-footer">
          <button type="button" data-autofocus className="cm-btn-cancel" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`cm-btn-confirm ${danger ? 'cm-btn-danger' : ''}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

const ConfirmModal = ({ open, ...props }) => (open ? <ConfirmDialog {...props} /> : null);

export default ConfirmModal;
